export const imageVariants = {
  front: {
    opacity: 1,
    x: 0,
    y: 0,
    zIndex: 1,
    transition: {
      duration: 0.8, // Adjust the duration as needed
      ease: [0.25, 1, 0.5, 1], // This is a common easing function for smooth transitions
    },
  },
  back: {
    opacity: 0.8,
    x: 60,
    y: 60,
    zIndex: 0,
    transition: {
      duration: 0.8, // Adjust the duration as needed
      ease: [0.25, 1, 0.5, 1], // This is a common easing function for smooth transitions
    },
  },
};
